var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import RouteNames from "@/app/router/routes";
import BackgroundTasksIndicator from "@/app/vues/components/background-tasks-indicator.vue";
/**
 * The strip under the logo in the left sidebar: who is signed in (with My Profile and Sign Out, which
 * are also in the menu list) and status icons (background tasks now, notifications later). It stands
 * in for the hidden top bar, because every page puts its own title and buttons where the top bar
 * would be.
 */
let SidebarStatusBar = class SidebarStatusBar extends Vue {
    constructor() {
        super(...arguments);
        this.userMenuOpen = false;
        this.routes = RouteNames;
    }
    mounted() {
        document.addEventListener("click", this.onDocumentClick);
    }
    beforeUnmount() {
        document.removeEventListener("click", this.onDocumentClick);
    }
    get displayName() {
        return this.loginState.displayName || "";
    }
    get initials() {
        const words = this.displayName.split(/\s+/).filter(w => w.length > 0);
        if (words.length === 0)
            return "?";
        const first = words[0][0];
        const last = words.length > 1 ? words[words.length - 1][0] : "";
        return `${first}${last}`.toUpperCase();
    }
    /** Closes the user menu when clicking anywhere else. */
    onDocumentClick(event) {
        const user = this.$refs.user;
        if (this.userMenuOpen && user && !user.contains(event.target))
            this.userMenuOpen = false;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], SidebarStatusBar.prototype, "loginState", void 0);
SidebarStatusBar = __decorate([
    Component({
        name: "SidebarStatusBar",
        components: { BackgroundTasksIndicator }
    })
], SidebarStatusBar);
export default SidebarStatusBar;
